import ls from 'local-storage';

/**
 * sets local storage
 * @param   {*} key     local storage key
 * @return  {undefined} returns nothing
 */
export function setLocalStorage(key) {
  ls.set(key, true);
}

/**
 * gets local storage value
 * @param  {*} key    local storage key
 * @return {Boolean}  value
 */
export function getLocalStorage(key) {
  return ls.get(key) || false;
}

/**
 * keyDown handler for local storage reset
 * @param  {event} e    onKeyDown event
 * @return {undefined}  returns nothing
 */
export function clearLocalStorage(e) {
  const {altKey, code, shiftKey} = e;

  if (altKey && code === 'KeyC' && shiftKey) {
    ls.clear();
    window.location.reload(true);
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/localStorageHelper.js